import { render, staticRenderFns } from "./navTab.vue?vue&type=template&id=6662ef8a&scoped=true&"
import script from "./navTab.vue?vue&type=script&lang=js&"
export * from "./navTab.vue?vue&type=script&lang=js&"
import style0 from "./navTab.vue?vue&type=style&index=0&id=6662ef8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6662ef8a",
  null
  
)

export default component.exports